import React from "react";
import { AiOutlineCopyright } from "react-icons/ai";

const FooterBottom = () => {
  return (
    <div className="w-full bg-[#F5F5F3]">
      <div className="max-w-container mx-auto border-t border-gray-300 pt-10 pb-20">
        <p className="text-titleFont font-normal text-center text-lightText text-sm flex flex-col md:flex-row items-center justify-center gap-1">
          <span className="hidden md:inline-flex mr-1">
            <AiOutlineCopyright />
          </span>
          Copyright 2024 | RK Global Trader | Premium Exporter of Fruits & Vegetables from India | All Rights Reserved |
          <a 
            href="https://www.rkglobaltrader.com" 
            target="_blank" 
            rel="noreferrer" 
            className="ml-1 font-medium text-primeColor hover:text-black transition-colors duration-300"
            title="Visit RK Global Trader Website"
          >
            Visit RK Global Trader
          </a>
        </p>
        <p className="text-center text-xs text-lightText mt-2">
          RK Global Trader – Your trusted partner for international trade, agricultural exports, and global commerce solutions.
        </p>
      </div>
    </div>
  );
};

export default FooterBottom;
